angular.module("listingOverviewModule").component("listingAmenities", {
    templateUrl: "listingAmenities/listingAmenities.html",
    bindings: {
        amenities: '<'
    },
    controller: ["$document", "$timeout", "$sce", "$element", function($document, $timeout, $sce, $element) {
        var self = this;
        // Slugify function to convert amenity names into valid CSS class names
        this.slugify = function(text) {
            if (!text) return '';
            return text
                .toString() // Ensure it's a string
                .toLowerCase() // Convert to lowercase
                .trim() // Trim whitespace
                .replace(/\s+/g, '_') // Replace spaces with underscores
                .replace(/[^\w_]+/g, '') // Remove non-word characters (except underscore)
                .replace(/__+/g, '_'); // Replace multiple underscores with a single one
        };
    }]
});
